import React, { useState, useEffect } from "react";
import { offerAPI } from "../../utils/api";
import "./OfferBanner.css";

export default function OfferBanner() {
  const [offer, setOffer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchOffer();
  }, []);

  const fetchOffer = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await offerAPI.getCurrentOffer();
      
      if (data.success && data.offer) {
        setOffer(data.offer);
      }
    } catch (err) {
      console.error("Error fetching offer:", err);
      setError("Failed to load offer");
    } finally {
      setLoading(false);
    }
  };

  // Don't render anything if loading, error, or no offer
  if (loading || error || !offer) {
    return null;
  }

  return (
    <div className="mariamly-offer-banner">
      <div className="mariamly-offer-content">
        <div className="mariamly-offer-text">
          {offer}
        </div>
      </div>
    </div>
  );
}
